<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="oauthClientForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                oauthClientForm: () => import('../oauth/forms/OauthClientForm.vue'),
                headers: [
                    { text: 'Client Name', value: 'clientName' },
                    { text: 'Website Url', value: 'websiteUrl' },
                    { text: 'Client Identifier', value: 'clientIdentifier' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    users: [],
                    items: []
                },
                sorting: [
                    { column: "clientName", direction: "ascending" },
                    { column: "userId", direction: "ascending" },
                ],
                itemsField: 'oauthClients',
                apiMethod: 'OauthClients',
                claimName: 'OauthClients',
                formTitle: 'Oauth Client',
                excelTitle: 'Oauth Clients',
                hasEditPage: true,
            }
        },
    };
</script>
